import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { propArrayShape, propChildren, propNumber, propStr, } from '../../../../../helpers/custom-prop-types';
import CheckBoxListColumnComponent from './CheckBoxListColumnComponent';
const CheckBoxListEspeciallyParts = (props) => {
    const { description, descriptionClassName, form, label, lists, maxCount, name, noMessage, other, subDescription, } = props;
    const currentValue = useSelector((state) => formValueSelector(form)(state, `information.${name}`));
    const { inputListIds, viewListIds } = useMemo(() => {
        const viewLists = Object.keys(currentValue)
            .map((key) => (Object.assign({ id: key }, currentValue[key])))
            .filter((v) => v.check);
        return {
            inputListIds: viewLists
                .filter((v) => v.especially)
                .map((v) => v.id.toString()),
            viewListIds: viewLists.map((v) => v.id),
        };
    }, [currentValue]);
    return (_jsxs("div", Object.assign({ className: 'form form-solution' }, { children: [_jsxs("h3", { children: [label, description && (_jsx("small", Object.assign({ className: descriptionClassName }, { children: description })))] }), subDescription && (_jsx("div", Object.assign({ className: 'profile_sub_description' }, { children: _jsx("div", Object.assign({ className: 'form_sub_text' }, { children: subDescription })) }))), viewListIds.length === 0 ? (_jsx("small", { children: noMessage })) : (_jsx("ul", Object.assign({ className: 'inline-multiple-checkbox' }, { children: viewListIds.map((viewListId) => {
                    const isDisabled = maxCount > 0 &&
                        inputListIds.length >= maxCount &&
                        !inputListIds.includes(viewListId.toString());
                    return (_jsx(CheckBoxListColumnComponent, { fieldName: 'especially', id: viewListId, isDisabled: isDisabled, lists: lists, name: name }, viewListId));
                }) }))), other] })));
};
CheckBoxListEspeciallyParts.propTypes = {
    description: propStr().isRequired,
    descriptionClassName: propStr().isRequired,
    form: propStr().isRequired,
    label: propStr().isRequired,
    lists: propArrayShape().isRequired,
    maxCount: propNumber().isRequired,
    name: propStr().isRequired,
    noMessage: propStr().isRequired,
    other: propChildren(),
    subDescription: propStr(),
};
CheckBoxListEspeciallyParts.defaultProps = {
    other: undefined,
    subDescription: undefined,
};
export default CheckBoxListEspeciallyParts;
